var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfflineSync(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "4.5 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5998_10540)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 18,
    r: 17.5,
    fill: "white",
    stroke: "#CBD2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 12V16.5H26.25",
    stroke: "#CBD2D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 24V19.5H18.75",
    stroke: "#CBD2D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1898 15.4163C15.0056 15.937 15.2783 16.5084 15.7989 16.6927C16.3196 16.8769 16.891 16.6042 17.0752 16.0835L15.1898 15.4163ZM27.27 13.2299L26.5627 13.9369C26.5701 13.9443 26.5776 13.9515 26.5852 13.9587L27.27 13.2299ZM30.0652 17.2287C30.4677 17.6069 31.1006 17.5872 31.4788 17.1847C31.857 16.7822 31.8373 16.1494 31.4348 15.7712L30.0652 17.2287ZM14.9348 18.7712C14.5323 18.393 13.8994 18.4127 13.5212 18.8152C13.1431 19.2176 13.1627 19.8505 13.5652 20.2287L14.9348 18.7712ZM17.73 22.7699L18.4373 22.063C18.4299 22.0556 18.4224 22.0483 18.4148 22.0412L17.73 22.7699ZM29.8102 20.5835C29.9945 20.0629 29.7217 19.4915 29.2011 19.3072C28.6804 19.123 28.109 19.3957 27.9248 19.9163L29.8102 20.5835ZM17.0752 16.0835C17.7338 14.2223 19.3013 12.8292 21.2269 12.3935L20.7855 10.4428C18.1901 11.03 16.0775 12.9078 15.1898 15.4163L17.0752 16.0835ZM21.2269 12.3935C23.1525 11.9578 25.167 12.5405 26.5627 13.9369L27.9773 12.523C26.0961 10.6409 23.3809 9.85555 20.7855 10.4428L21.2269 12.3935ZM26.5852 13.9587L30.0652 17.2287L31.4348 15.7712L27.9548 12.5012L26.5852 13.9587ZM13.5652 20.2287L17.0452 23.4987L18.4148 22.0412L14.9348 18.7712L13.5652 20.2287ZM17.0227 23.4769C18.9039 25.359 21.6191 26.1443 24.2145 25.5571L23.7731 23.6064C21.8475 24.0421 19.833 23.4594 18.4373 22.063L17.0227 23.4769ZM24.2145 25.5571C26.8099 24.9698 28.9225 23.0921 29.8102 20.5835L27.9248 19.9163C27.2662 21.7775 25.6987 23.1707 23.7731 23.6064L24.2145 25.5571Z",
    fill: "#CBD2D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5998_10540",
    x: 0.5,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5998_10540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5998_10540",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineSync);
export default __webpack_public_path__ + "static/media/offline-sync.f369717b8038829e5f42a1ea9f5d7d16.svg";
export { ForwardRef as ReactComponent };